import { render, staticRenderFns } from "./SpecialPriceAdjList_List.vue?vue&type=template&id=1c64b1c8&"
import script from "./SpecialPriceAdjList_List.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports